<dff-side [observable]="dataLoaded$">
    @if (sideTitel$ | async; as sideTitel) {
        <button mat-icon-button type="button" class="button-back" [routerLink]="['..']" title="Tilbage" aria-label="Tilbage til mine dokumenter">
            <mat-icon svgIcon="arrow-left"></mat-icon>
        </button>
        <dff-side-titel>
            {{ sideTitel }}
        </dff-side-titel>
    }
    <dff-pdf-fremviser id="qa-pdf-mine-dokumenter-component" [dokumentUrler]="pdfUrls$ | async" (dataLoaded)="onDataLoaded()"></dff-pdf-fremviser>
</dff-side>
